<template>
  <div class="check-box-wrapper">
    <div class="check-box-container">
      <input :id="'toggler-'+nameCheck"
             :name="'toggler-'+nameCheck"
             type="checkbox" v-model="checkActive"
             @change="$emit('changeValue', checkActive)">
      <label :for="'toggler-'+nameCheck">
        <span class="toggler-on"/>
        <span class="toggler-off"/>
      </label>
    </div>
  </div>

</template>

<script>
export default {
  name: "Toggle",
  props: {
    isActiveWatcher: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
    },
    nameCheck: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      checkActive: false
    }
  },
  watch: {
    active() {
      if(this.isActiveWatcher) {
        this.checkActive = this.active;
      }
    }
  },
  mounted() {
    this.checkActive = !!this.active;
  },

}
</script>

<style scoped lang="scss">
.check-box-wrapper {
  min-width: 45px;
  max-width: 45px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.check-box-container {
  width: 100%;
  transition: opacity .6s ease;
}

.check-box-container input {
  display: none;
}

.check-box-container label {
  width: 45px;
  height: 22px;
  margin: 0 2px;
  border-radius: 23px;
  display: block;
  position: relative;
  background: rgba(var(--color-purple-rgba), .2);
  cursor: pointer;
  transition: all .3s ease;
}

.check-box-container input:checked + label{
  background: var(--color-dark-purple);
}

.check-box-container input:checked + label::after{
  background: var(--color-must-dark-purple);
}


.check-box-container label::after {
  display: block;
  border-radius: 50%;
  background: rgba(var(--color-purple-rgba), .4);
  content: '';
  animation-name: toggler-size;
  animation-duration: 0.15s;
  animation-timing-function: ease-out;
  animation-iteration-count: 1;
  animation-play-state: running;
  width: 18px;
  height: 18px;
}

.check-box-container input:checked + label::after, .check-box-container input:checked + label .toggler-on, .check-box-container input:checked + label .check-box-container-off {
  left: calc(100% - 11px);
}
.check-box-container label::after, .check-box-container label .check-box-container-on, .check-box-container label .check-box-container-off {
  top: 50%;
  left: 11px;
  width: 18px;
  height: 18px;
}

.check-box-container label::after, .check-box-container label .check-box-container-on, .check-box-container label .check-box-container-off, .check-box-container label::before, {
  position: absolute;
  transform: translateY(-50%) translateX(-50%);
  transition: left 0.15s ease-in-out, background-color 0.2s ease-out, width 0.15s ease-in-out, height 0.15s ease-in-out, opacity 0.15s ease-in-out, filter .6s ease;
}

.check-box-container input:checked + label::after, .check-box-container input:checked + label::before {
  animation-name: toggler-size2;
}

.check-box-container .toggler-on, .check-box-container .toggler-off {
  opacity: 1;
  z-index: 2;
  position: relative;
}

.check-box-container input:checked + label .toggler-off, .check-box-container input:not(:checked) + label .toggler-on {
  width: 0;
  height: 0;
  opacity: 0;
}


</style>